import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useUsers, useNavigation } from '@/hooks'

export const UserPage = () => {
  const { t } = useTranslation()
  const navigation = useNavigation()
  const { userId } = navigation.params

  const users = useUsers()
  const userData = useMemo(
    () => users.query.data?.find(({ id }) => id === Number(userId)),
    [users.query.data, userId],
  )
  const userName = useMemo(() => userData?.name ?? '', [userData])

  return (
    <div>
      <div className="mt-10 flex flex-row justify-between p-8">
        <div className="flex flex-row items-center gap-2">
          <div className="text-4xl font-bold text-slate-800">{`User: ${userName}`}</div>
        </div>
      </div>
      <div className="p-8"></div>
    </div>
  )
}
